module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-left-top-ties.e91a3ced.png";